import { Component, HostListener, Renderer2, Inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Event, Router, ActivatedRoute } from '@angular/router';
import { LocationStrategy, DOCUMENT } from '@angular/common';
import { UtilService } from './service/util.service'
import { UserIdleService } from 'angular-user-idle';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UrlService } from './service/url.service';
import { AdobeAnalyticsDigitalDataService } from './service/adobe-analytics-digitaldata.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {

  title = 'pre-qualifications';
  timeout;
  loader = true;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  ticks!: Date;
  previousUrl: string = null;
  currentUrl: string = null;


  private subscription: Subscription = new Subscription();
  constructor(private router: Router,
    private location: LocationStrategy,
    private utilService: UtilService,
    private userIdle: UserIdleService,
    private _activatedRoute: ActivatedRoute,
    private renderer2: Renderer2,
    private adobeAnalyticsData: AdobeAnalyticsDigitalDataService,
    private urlService: UrlService,
    @Inject(DOCUMENT) private document: Document
  ) {

    router.events.subscribe((event: Event) => {
      this.navigationInterceptor(event);
      if (event instanceof NavigationEnd && event.url && event.url != null) {
        this.utilService.SIDE_BAR_EVENT.next(event.url)
      }
    });
  }
  ngOnInit(): void {
    this.userIdle.startWatching();
    // this.loadAutoComplete();


    // Start watch when time is up.
    this.subscription = this.userIdle.onTimeout().subscribe(() => {
    });

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
    });
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        this.utilService.LOADER.next(false);
      }
    })
    document.addEventListener('visibilitychange', () => {
      if (this.currentUrl.indexOf("summary") > -1) {
        if (document.visibilityState == 'hidden') {
          if (JSON.parse(sessionStorage.getItem("startTimer for summaryPage")) == true) {
            let curPreQual = this.utilService.getSessionStorage();
            this.utilService.saveJson(curPreQual).subscribe(obj => {
            })
          }
        }
      }
    });
  }




  navigationInterceptor(event: Event): void {
    if (event instanceof NavigationStart) {
      this.utilService.isSidebarVisible.next(false);

      if (event.url.split("/").indexOf("verify-identity") >= 0 || event.url.split("/").indexOf("income")) {
        this.loader = false;
      }
      else {
        this.loader = true
      }
      // if(!event.url.split("/").indexOf("verify-identity")){
      //   this.loader = true;
      // }
    }
    if (event instanceof NavigationEnd) {
      this.utilService.isSidebarVisible.next(true);

      // Hide loading indicator
      this.timeout = setTimeout(() => {
        clearTimeout(this.timeout);
        this.loader = false;
      }, 1000);

      this.utilService.backButtonDisable()


      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.urlService.setPreviousUrl(
        this.previousUrl
      );
      this.adobeTracking(event)
    }
  }
  adobeTracking(event: NavigationEnd) {
    let digitalData = this.adobeAnalyticsData.load(event.url)


    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalData + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    } else {
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalData + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }
    var script = document.createElement('script');
    script.src = environment.cookieBinder.url;
    script.id = "cookie-tracking"
    if (!document.getElementById("cookie-tracking")) {
      $("head").append(script.outerHTML);
    }
  }

  closeModal() {
    //close popup and reset timer
    this.userIdle.resetTimer();
  }

  logout() {
    //close popup and stoptimer
    this.userIdle.resetTimer();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
